//src/admin/pages/AdminProductsBase.js
import React, { useState, useEffect, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaBoxOpen,
  FaSearch,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getAdminProducts, getAdminCategories } from "../../services/adminProducts.api";
import { deleteAdminProduct } from "../../services/adminProducts.api";
import { FaStar, FaFire, FaTags } from "react-icons/fa";
import { FiEdit2 } from "react-icons/fi";

function AdminProductsBase({ filterType = "all", rightAction = null }) {
    const navigate = useNavigate();
    const { lang } = useContext(AdminLanguageContext);

    const TEXT = {
  EN: {
    title: "Products",
    add: "Add Product",
    search: "Search products...",
    image: "Image",
    titleCol: "Title",
    price: "Price",
    stock: "Stock",
    actions: "Actions",
    loading: "Loading products...",
    empty: "No products found.",
    edit: "Edit",
    delete: "Delete",
    prev: "Prev",
    next: "Next",
    deleteTitle: "Delete Product?",
    deleteText: "This action cannot be undone.",
    cancel: "Cancel",
    count: "Total products",
    product: "Product",
    category: "Category",
    status: "Status",
    new: "New",
    bestseller: "Bestseller",
    sale: "Sale",
    noCategory: "No category",
    all: "All",
  active: "Active",
  hidden: "Hidden",
  },
  AR: {
    title: "المنتجات",
    add: "إضافة منتج",
     all: "الكل",
  active: "نشط",
  hidden: "مخفي",
    search: "بحث عن المنتجات...",
    image: "الصورة",
    titleCol: "العنوان",
    price: "السعر",
    stock: "المخزون",
    actions: "الإجراءات",
    loading: "جاري تحميل المنتجات...",
    empty: "لا توجد منتجات.",
    edit: "تعديل",
    delete: "حذف",
    prev: "السابق",
    next: "التالي",
    deleteTitle: "حذف المنتج؟",
    deleteText: "لا يمكن التراجع عن هذا الإجراء.",
    cancel: "إلغاء",
    count: "إجمالي المنتجات",
    product: "المنتج",
    category: "الفئة",
    status: "الحالة",
    new: "جديد",
    bestseller: "الأكثر مبيعاً",
    sale: "تخفيض",
    noCategory: "بدون فئة",
  },
}[lang];

    const [isOpen, setIsOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");

    const [searchOpen, setSearchOpen] = useState(false);
    const [visibilityFilter, setVisibilityFilter] = useState("All");

    const [page, setPage] = useState(1);
    const perPage = 6;

    const [deleteId, setDeleteId] = useState(null);

const isFilteredView = filterType !== "all";
const [categories, setCategories] = useState([]);

  const titleMap = {
  all: TEXT.title,
  new: lang === "AR" ? "المنتجات الجديدة" : "New In Products",
  bestseller: lang === "AR" ? "الأكثر مبيعاً" : "Bestseller Products",
  sale: lang === "AR" ? "منتجات التخفيض" : "On Sale Products",
};

useEffect(() => {
  setPage(1);
}, [search, visibilityFilter, filterType]);

useEffect(() => {
  getAdminCategories()
    .then(setCategories)
    .catch(console.error);
}, []);

    useEffect(() => {
  setLoading(true);
  getAdminProducts()
    .then((data) => {
      let mapped = data.map((p) => ({
        ...p,
        title_en: p.name_en,
        price: p.base_price,
      }));

      // ✅ NEW FILTER LOGIC
      if (filterType === "new") {
        mapped = mapped.filter((p) => p.is_new_in);
      }

      if (filterType === "bestseller") {
        mapped = mapped.filter((p) => p.is_bestseller);
      }

      if (filterType === "sale") {
        mapped = mapped.filter((p) => p.on_sale);
      }

      setProducts(mapped);
    })
    .catch(console.error)
    .finally(() => setLoading(false));
}, [filterType]);



    const filtered = products.filter((p) => {
  const q = search.toLowerCase();

  const matchesSearch =
    !search ||
    (p.name_en || "").toLowerCase().includes(q) ||
    (p.name_ar || "").toLowerCase().includes(q) ||
    (p.public_id || "").toLowerCase().includes(q);

  const matchesVisibility =
    visibilityFilter === "All"
      ? true
      : visibilityFilter === "active"
      ? p.is_active === 1
      : p.is_active === 0;

  return matchesSearch && matchesVisibility;
});



    const sorted = [...filtered].sort((a, b) => {
        if (!sortBy) return 0;

        let valueA = a[sortBy];
        let valueB = b[sortBy];

        if (typeof valueA === "string") valueA = valueA.toLowerCase();
        if (typeof valueB === "string") valueB = valueB.toLowerCase();

        if (sortDirection === "asc") return valueA > valueB ? 1 : -1;
        return valueA < valueB ? 1 : -1;
    });

    const totalPages = Math.ceil(sorted.length / perPage);
    const paginated = sorted.slice((page - 1) * perPage, page * perPage);

    const changeSort = (field) => {
        if (sortBy === field) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortBy(field);
            setSortDirection("asc");
        }
    };

    const getSortIcon = (field) => {
        if (sortBy !== field) return <FaSort className="inline opacity-40 ml-1" />;
        return sortDirection === "asc" ? (
            <FaSortUp className="inline ml-1" />
        ) : (
            <FaSortDown className="inline ml-1" />
        );
    };

    const confirmDelete = async () => {
  await deleteAdminProduct(deleteId);
  setProducts((prev) => prev.filter((p) => p.id !== deleteId));
  setDeleteId(null);
};


  const groupVariantsByColor = (variants = []) => {
  // ✅ 1) DEDUPE: keep only ONE row per variant.id (joins were duplicating it)
  const byId = new Map();

  (variants || []).forEach((v) => {
    if (!v) return;

    const id = v.id != null ? String(v.id) : null;

    // normalize
    const normalized = {
      id,
      color_name: v.color_name || "Unknown",
      color_hex: v.color_hex || "#ccc",
      size: v.size != null ? String(v.size) : "",
      stock_qty: Number(v.stock_qty || 0),
    };

    if (id) {
      // keep first (or keep the bigger qty if you want extra safety)
      if (!byId.has(id)) byId.set(id, normalized);
    } else {
      // fallback if id missing (rare): unique by color+hex+size+qty
      const fallbackKey = `${normalized.color_name}|${normalized.color_hex}|${normalized.size}|${normalized.stock_qty}`;
      if (!byId.has(fallbackKey)) byId.set(fallbackKey, normalized);
    }
  });

  const uniqueVariants = Array.from(byId.values()).filter(
    (v) => v.stock_qty > 0
  );

  // ✅ 2) GROUP BY COLOR + SUM TOTALS
  const colorsMap = {};

  uniqueVariants.forEach((v) => {
    const cKey = `${v.color_name}|${v.color_hex}`;

    if (!colorsMap[cKey]) {
      colorsMap[cKey] = {
        color_name: v.color_name,
        color_hex: v.color_hex,
        total: 0,
        sizes: [],
      };
    }

    colorsMap[cKey].total += v.stock_qty;
    colorsMap[cKey].sizes.push({ size: v.size, qty: v.stock_qty });
  });

  // ✅ 3) sort sizes nicely
  return Object.values(colorsMap).map((c) => ({
    ...c,
    sizes: c.sizes.sort((a, b) => {
      const na = Number(a.size);
      const nb = Number(b.size);
      if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
      return String(a.size).localeCompare(String(b.size));
    }),
  }));
};



    return (
        <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
            <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""} w-full transition-all duration-300`}>
                <AdminHeader setIsOpen={setIsOpen} />

                <main className="p-4 sm:p-6 animate-fadeSlide">

                    <div className="flex items-center justify-between mb-5">
  <div className="mx-1 flex items-center gap-2">
    <div className="flex items-center justify-center w-6 h-6">
      {filterType === "new" && <FaStar className="text-gray-900 text-[16px]" />}
{filterType === "bestseller" && <FaFire className="text-gray-900 text-[16px]" />}
{filterType === "sale" && <FaTags className="text-gray-900 text-[16px]" />}
{filterType === "all" && <FaBoxOpen className="text-gray-900 text-[16px]" />}
    </div>

    <div className="flex items-baseline gap-2">
      <h1 className="text-[18px] font-semibold text-gray-900">
        {titleMap[filterType]}
      </h1>
    </div>
  </div>

  <div className="flex items-center gap-2">
    {rightAction}

    {!isFilteredView && (
      <button
        onClick={() => navigate("/admin/products/add")}
        className="
          h-8 px-3
          bg-[#1f1f1f]
          text-white
          rounded-lg
          shadow-[0_1px_0_rgba(0,0,0,0.08),0_3px_8px_rgba(0,0,0,0.2)]
          text-sm font-medium
          hover:bg-black
          active:shadow-[inset_0_2px_6px_rgba(0,0,0,0.3)]
          transition
          flex items-center gap-2
        "
      >
        {TEXT.add}
      </button>
    )}
  </div>
</div>

                  

                   <div className="
hidden md:block
bg-white
border border-[#e3e3e3]
rounded-[14px]
overflow-visible
shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
">

{/* 🔥 NEW TOP HEADER (LIKE PRODUCTS PAGE) */}
<div className="relative flex items-center justify-between px-4 py-3 border-b border-[#e3e3e3] bg-white rounded-t-[14px] overflow-visible">

{/* LEFT SIDE */}
{!searchOpen ? (

  <div className="flex items-center gap-1">

    {/* FILTER BUTTONS */}
    {[
      { label: TEXT.all || "All", value: "All" },
      { label: TEXT.active || "Active", value: "active" },
      { label: TEXT.hidden || "Hidden", value: "hidden" },
    ].map((f) => {
      const active = visibilityFilter === f.value;

      return (
        <button
          key={f.value}
          onClick={() => setVisibilityFilter(f.value)}
          className={`
            px-3 py-[5px]
            text-[13px] font-medium
            rounded-md
            transition
            ${
              active
                ? "bg-gray-200 text-gray-900"
                : "text-gray-600 hover:bg-gray-200"
            }
          `}
        >
          {f.label}
        </button>
      );
    })}

  </div>

) : (

  <div className="flex items-center gap-3 w-full">

    {/* SEARCH INPUT */}
    <div className="
      flex items-center justify-between
      flex-1
      h-8
      px-3
      bg-white
      border border-gray-300
      rounded-lg
      shadow-sm
      focus-within:border-gray-500
      focus-within:ring-2
      focus-within:ring-gray-200
      transition
    ">

      <div className="flex items-center gap-2 flex-1">
        <FaSearch className="text-gray-400 text-sm" />
        <input
          autoFocus
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={TEXT.search}
          className="flex-1 outline-none text-sm"
        />
      </div>

      <button
        onClick={() => {
          setSearch("");
          setSearchOpen(false);
        }}
        className="w-5 h-5 flex items-center justify-center rounded-full border border-gray-500 text-gray-500 hover:bg-gray-100"
      >
        ✕
      </button>

    </div>

    <button
      onClick={() => {
        setSearch("");
        setSearchOpen(false);
      }}
      className="px-3 h-8 bg-white border border-gray-300 rounded-lg shadow-sm text-sm font-medium"
    >
      {TEXT.cancel}
    </button>

  </div>

)}

{/* RIGHT SIDE */}
<div className="flex items-center gap-2">

  {!searchOpen && (
    <button
      onClick={() => setSearchOpen(true)}
      className="
        flex items-center justify-center gap-1
        px-2 h-9
        bg-white
        border border-gray-300
        rounded-lg
        shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
        hover:bg-gray-50
        active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
        transition
      "
    >
      <FaSearch className="text-gray-600 text-sm" />
      <svg width="14" height="14" viewBox="0 0 20 20">
        <path
          d="M3 5H17M6 10H14M9 15H11"
          stroke="#4B5563"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </button>
  )}

</div>

</div>
                        <table
                            dir={lang === "AR" ? "rtl" : "ltr"}
                            className="w-full min-w-[700px] text-center"
                          >
                            <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
                                <tr>
  <th className="px-4 py-1.5 text-center">{TEXT.product}</th>
  <th className="px-4 py-1.5 text-center cursor-pointer" onClick={() => changeSort("title_en")}>
    {TEXT.titleCol} {getSortIcon("title_en")}
  </th>
  <th className="px-4 py-1.5 text-center">{TEXT.category}</th>
  {filterType === "sale" ? (
  <>
    <th className="px-3 py-1.5 text-center">{lang === "AR" ? "السعر الأساسي" : "Base"}</th>
    <th className="px-3 py-1.5 text-center">{lang === "AR" ? "الخصم %" : "Discount %"}</th>
    <th className="px-3 py-1.5 text-center">{lang === "AR" ? "قيمة الخصم" : "Saved"}</th>
    <th className="px-3 py-1.5 text-center">{lang === "AR" ? "السعر النهائي" : "Final"}</th>
  </>
) : (
  <th
    className="px-4 py-1.5 text-center cursor-pointer"
    onClick={() => changeSort("price")}
  >
    {TEXT.price} {getSortIcon("price")}
  </th>
)}
  <th className="px-4 py-1.5 text-center cursor-pointer" onClick={() => changeSort("stock")}>
    {TEXT.stock} {getSortIcon("stock")}
  </th>
  <th className="px-4 py-1.5 text-center rounded-tr-[14px]">
    {TEXT.actions}
  </th>
</tr>
                            </thead>

                            <tbody>
 {loading ? (
  [...Array(6)].map((_, i) => (
    <tr key={i} className="animate-pulse border-b">
      
      <td className="py-3">
        <div className="w-20 h-3 bg-gray-200 rounded mx-auto"></div>
      </td>

      <td className="py-3">
        <div className="w-28 h-3 bg-gray-200 rounded mx-auto"></div>
      </td>

      <td>
        <div className="w-20 h-3 bg-gray-200 rounded mx-auto"></div>
      </td>

      <td>
        <div className="w-16 h-3 bg-gray-200 rounded mx-auto"></div>
      </td>

      <td>
        <div className="w-16 h-3 bg-gray-200 rounded mx-auto"></div>
      </td>

      <td>
        <div className="w-16 h-6 bg-gray-200 rounded mx-auto"></div>
      </td>

    </tr>
  ))
) : paginated.length === 0 ? (
    <tr>
      <td colSpan={filterType === "sale" ? 9 : 6} className="py-10 text-center">
  <div className="flex flex-col items-center gap-2 text-gray-500">
    <FaBoxOpen className="text-2xl opacity-40" />
    <span className="text-sm">{TEXT.empty}</span>
  </div>
</td>
    </tr>
  ) : (
    paginated.map((p) => {
      const base = Number(p.price || 0);
      const percent = Number(p.sale_percent || 0);
      const hasDiscount = Boolean(p.on_sale) && percent > 0;
      const discount = hasDiscount ? (base * percent) / 100 : 0;
      const final = hasDiscount ? base - discount : base;

      return (
        <tr
          key={p.id}
          className="group border-b border-[#f1f1f1] hover:bg-[#f6f6f7] transition cursor-pointer text-[12.5px]"
          onClick={() => navigate(`/admin/products/edit/${p.id}`)}
        >

          {/* PRODUCT */}
          <td className="px-2 py-1 w-[280px] text-center">
            <div className="flex items-center gap-3">
              <img
                src={p.image || "/no-image.png"}
                className="w-8 h-8 object-cover rounded"
                alt=""
                onError={(e) => (e.target.src = "/no-image.png")}
              />
              <span className="font-medium">
                {lang === "AR" ? p.name_ar || p.name_en : p.name_en}
              </span>
            </div>
          </td>

          {/* TITLE */}
          <td className="px-4 py-1 text-center">
            <div className="font-semibold">{p.name_en}</div>
            <div className="text-xs text-gray-400">ID: {p.public_id}</div>
          </td>

          {/* CATEGORY */}
          <td className="px-4 py-1 text-center">
            {p.categories?.[0] || TEXT.noCategory}
          </td>

          {/* PRICE */}
          {filterType === "sale" ? (
  <>
    {/* BASE */}
    <td className="px-3 py-1 text-center">
      <span className="text-gray-500 text-[12px]">
        ${base.toFixed(2)}
      </span>
    </td>

    {/* DISCOUNT % */}
    <td className="px-3 py-1 text-center">
      <span className="inline-flex px-2 py-[2px] rounded-md text-[11px] font-medium bg-red-50 text-red-700">
        {percent}%
      </span>
    </td>

    {/* SAVED */}
    <td className="px-3 py-1 text-center">
      <span className="text-red-600 font-medium text-[12px]">
        -${discount.toFixed(2)}
      </span>
    </td>

    {/* FINAL */}
    <td className="px-3 py-1 text-center">
      <span className="font-semibold text-gray-900">
        ${final.toFixed(2)}
      </span>
    </td>
  </>
) : (
  <td className="px-3 py-1 text-center">
    ${final.toFixed(2)}
  </td>
)}

          {/* STOCK */}
          <td className="px-3 py-1 text-center">
            {groupVariantsByColor(p.variants).reduce((sum, c) => sum + c.total, 0)}
          </td>

          {/* ACTIONS */}
          <td className="px-3 py-1 text-center">
            <div className="flex justify-center gap-3">
              <button
  onClick={(e) => {
    e.stopPropagation();
    navigate(`/admin/products/edit/${p.id}`);
  }}
  className="
    w-8 h-8
    flex items-center justify-center
    rounded-md
    text-gray-600
    hover:bg-gray-100
    hover:text-gray-900
    transition
  "
>
  <FaEdit className="text-[15px]" />
</button>

              {!isFilteredView && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(p.id);
                  }}
                  className="text-red-600"
                >
                  <FaTrash />
                </button>
              )}
            </div>
          </td>

        </tr>
      );
    })
  )}
</tbody>
<tfoot>
<tr className="bg-[#f6f6f7] border-t border-[#e3e3e3]">
<td
  colSpan={filterType === "sale" ? 9 : 6}
  className={`px-4 py-2 ${
    lang === "EN"
      ? "rounded-b-[14px]"
      : "rounded-b-[14px]"
  }`}
>

<div className={`flex items-center justify-between text-sm text-gray-600 ${lang === "AR" ? "flex-row-reverse" : ""}`}>

  {/* COUNT */}
  <span className="text-gray-500 text-sm">
    {filtered.length} {lang === "EN" ? "products" : "منتجات"}
  </span>

  {/* PAGINATION */}
  <div className="flex items-center gap-1">

    {/* PREV */}
    <button
      onClick={() => setPage((p) => Math.max(1, p - 1))}
      disabled={page === 1}
      className={`w-7 h-7 flex items-center justify-center rounded-md border bg-gray-200 font-bold ${
        page === 1
          ? "opacity-40 cursor-not-allowed"
          : "hover:bg-gray-300"
      }`}
    >
      {"<"}
    </button>

    {/* PAGE INFO */}
    <span className="mx-2 text-gray-900 font-semibold">
      {page}-{totalPages}
    </span>

    {/* NEXT */}
    <button
      onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
      disabled={page === totalPages}
      className={`w-7 h-7 flex items-center justify-center rounded-md border bg-gray-200 font-bold ${
        page === totalPages
          ? "opacity-40 cursor-not-allowed"
          : "hover:bg-gray-300"
      }`}
    >
      {">"}
    </button>

  </div>

</div>

</td>
</tr>
</tfoot>
                        </table>
                    </div>

                    {/* MOBILE CARDS */}
<div className="md:hidden">
  {loading ? (
  <div className="space-y-3">
    {[...Array(4)].map((_, i) => (
      <div key={i} className="bg-white rounded-xl p-4 shadow animate-pulse space-y-3">

        <div className="flex gap-3">
          <div className="w-16 h-16 bg-gray-200 rounded"></div>
          <div className="space-y-2">
            <div className="w-28 h-3 bg-gray-200 rounded"></div>
            <div className="w-20 h-2 bg-gray-200 rounded"></div>
          </div>
        </div>

        <div className="w-full h-3 bg-gray-200 rounded"></div>
        <div className="w-full h-3 bg-gray-200 rounded"></div>

      </div>
    ))}
  </div>
) : paginated.length === 0 ? (
<div className="flex flex-col items-center justify-center py-10 text-gray-500 gap-2">
  <FaBoxOpen className="text-2xl opacity-40" />
  <span className="text-sm">{TEXT.empty}</span>
</div>
  ) : (
  <>
    {paginated.map((p) => (
      <div
        key={p.id}
        className="bg-white rounded-xl shadow p-4 space-y-3 mb-3"
      >
        {/* Header */}
        <div className="flex items-center gap-3">
          <img
            src={p.image || "/no-image.png"}
            className="w-16 h-16 rounded object-cover"
            alt=""
          />
          <div>
            <div className="font-bold">{p.title_en}</div>
            <div className="text-xs text-gray-400">ID: {p.public_id}</div>
            {p.name_ar && (
              <div className="text-xs text-gray-500">{p.name_ar}</div>
            )}
          </div>
        </div>

        {/* Price */}
        <div className="flex justify-between text-sm">
  <span>{TEXT.price}</span>

  {!p.on_sale ? (
    <span className="font-bold">${Number(p.price).toFixed(2)}</span>
  ) : (
    <div className="text-right">
      <div className="text-xs text-gray-500 line-through">
        ${Number(p.price).toFixed(2)}
      </div>
      <div className="text-xs font-bold text-red-600">
        -{p.sale_percent}%
      </div>
      <div className="font-bold text-green-600">
        $
        {(
          Number(p.price) -
          (Number(p.price) * Number(p.sale_percent || 0)) / 100
        ).toFixed(2)}
      </div>
    </div>
  )}
</div>


        {/* Stock */}
        <div>
  {/* TOTAL */}
  <div className="text-sm font-bold mb-2">
    {TEXT.stock}: {groupVariantsByColor(p.variants).reduce((sum, c) => sum + c.total, 0)}
  </div>

  {/* COLORS */}
  <div className="space-y-2">
    {groupVariantsByColor(p.variants).map((c, i) => (
      <div
        key={i}
        className="border rounded-lg p-2 bg-gray-50"
      >
        <div className="flex items-center gap-2 text-sm font-semibold mb-1">
          <span
            className="w-3 h-3 rounded-full border"
            style={{ backgroundColor: c.color_hex }}
          />
          {c.color_name}
          <span className="text-xs text-gray-500">
            ({c.total})
          </span>
        </div>

        <div className="flex flex-wrap gap-2 text-xs">
         {c.sizes.map((s, j) => {
  const lowStock = Number(s.qty) <= 3;

  return (
    <span
      key={j}
      className="px-2 py-0.5 border rounded-full bg-white"
    >
      {s.size}:{" "}
      <span
  style={{
    color: lowStock ? "#dc2626" : "inherit",
    fontWeight: lowStock ? "700" : "600",
  }}
>
  {s.qty}
</span>

    </span>
  );
})}

        </div>
      </div>
    ))}
  </div>
</div>


        {/* Bottom row: badges on the left + actions on the right */}
<div className="flex items-start justify-between gap-3 pt-2 border-t">
  {/* Badges (same style as desktop) */}
  <div className="flex flex-wrap gap-1">
    {p.on_sale ? (
      <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded">
        {TEXT.sale} {p.sale_percent}%
      </span>
    ) : (
      <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
        {TEXT.sale}
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-full h-[1px] bg-red-400 rotate-[-20deg]" />
        </span>
      </span>
    )}

    {p.is_bestseller ? (
      <span className="text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded">
        {TEXT.bestseller}
      </span>
    ) : (
      <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
        {TEXT.bestseller}
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-full h-[1px] bg-purple-400 rotate-[-20deg]" />
        </span>
      </span>
    )}

    {p.is_new_in ? (
      <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
        {TEXT.new}
      </span>
    ) : (
      <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
        {TEXT.new}
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-full h-[1px] bg-green-400 rotate-[-20deg]" />
        </span>
      </span>
    )}
  </div>

  {/* Actions */}
   <div className="flex gap-4">
  <button
  onClick={() => navigate(`/admin/products/edit/${p.id}`)}
  className="
    w-8 h-8
    flex items-center justify-center
    rounded-md
    text-gray-600
    hover:bg-gray-100
    hover:text-gray-900
    transition
  "
>
  <FaEdit className="text-[15px]" />
</button>

  {!isFilteredView && (
    <button
      className="text-red-600"
      onClick={() => setDeleteId(p.id)}
    >
      <FaTrash />
    </button>
  )}
</div>
</div>

      </div>
    ))}
 {/* ✅ MOBILE PAGINATION (NOW CORRECT) */}
  {totalPages > 1 && (
      <div className="flex items-center justify-between mt-4 text-sm bg-white p-3 rounded-lg shadow">
        
        <button
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          disabled={page === 1}
          className={`px-3 py-1 border rounded-md ${
            page === 1 ? "opacity-40 cursor-not-allowed" : ""
          }`}
        >
          {TEXT.prev}
        </button>

        <span className="font-medium text-gray-900">
          {page} / {totalPages}
        </span>

        <button
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          disabled={page === totalPages}
          className={`px-3 py-1 border rounded-md ${
            page === totalPages ? "opacity-40 cursor-not-allowed" : ""
          }`}
        >
          {TEXT.next}
        </button>

      </div>
    )}
  </>
)}

</div> 

                    {deleteId !== null && (
                        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
                            <div className="bg-white p-6 rounded-xl shadow-xl w-80">
                                <h2 className="text-lg font-bold text-red-600 mb-2">
                                    {TEXT.deleteTitle}
                                </h2>
                                <p className="mb-5">{TEXT.deleteText}</p>

                                <div className="flex justify-end gap-3">
                                    <button
                                        className="px-4 py-2 bg-gray-300 rounded-lg"
                                        onClick={() => setDeleteId(null)}
                                    >
                                        {TEXT.cancel}
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-red-500 text-white rounded-lg"
                                        onClick={confirmDelete}
                                    >
                                        {TEXT.delete}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                </main>
            </div>
        </div>
    );
}

export default AdminProductsBase;